let id = 0

const uniqueId = (prefix = '') => {
	return prefix + id++
}

export {
	uniqueId
}
